import axios from "axios";

export const emittedRetentionDocApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-emitted-retention-document`,
  headers: { "Content-Type": "application/json" },
});
